import Loading from './loading'

export default (Vue) => {
    Vue.component('loading', Loading)
}
